module.exports = __webpack_public_path__ + "static/media/2.b4f96f74.mp3";